/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetEvChargingSessionsPathParameters } from 'api/actions/get-ev-charging-sessions/get-ev-charging-sessions-path-parameters';
import { GetEvChargingSessionsResponse } from 'api/actions/get-ev-charging-sessions/get-ev-charging-sessions-response';

type GetEvChargingSessionsQueryParameters = Record<string, any>;

/**
 * The path of the GetEvChargingSessions action.
 */
export const getEvChargingSessionsActionPath = new SweetPath<keyof GetEvChargingSessionsPathParameters>(
  '/ev-charging-stations/{evChargingStationId}/sessions',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetEvChargingSessions actions.
 */
export default function createGetEvChargingSessionsAction(axios: AxiosInstance) {
  return function getEvChargingSessionsAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetEvChargingSessionsPathParameters;
    query?: GetEvChargingSessionsQueryParameters;
  }) {
    const path = getEvChargingSessionsActionPath.insert(parameters);

    return axios.get<GetEvChargingSessionsResponse, GetEvChargingSessionsResponse>(path, { params: query, headers });
  };
}
